import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Apply the saved theme before first paint. Light is the default (no attribute);
// only an explicit 'dark' choice sets data-theme, matching the DHsyslog site.
try {
  if (localStorage.getItem('portal_theme') === 'dark') {
    document.documentElement.setAttribute('data-theme', 'dark');
  }
} catch { /* localStorage unavailable (private mode) — fall back to light */ }

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
